export class Auth {
  isRefreshingToken = false

  isLogged() {
    return this.store
      ? this.store.getters['auth/loggedIn']
      : false
  }
}

const instance = new Auth()

function authHelper(app, { router, store }) {
  if (!store || !router) {
    throw new Error('Missing required params')
  }

  instance.store = store
  instance.router = router

  router.beforeEach(async (to) => {
    const requiresAuth = to.matched.some((route) => {
      return (
        route.meta.middleware &&
        route.meta.middleware.includes('auth')
      )
    })

    const requiresRole = to.matched.some((route) => {
      return (
        route.meta.middleware &&
        route.meta.middleware.includes('role')
      )
    })

    if (!requiresAuth) {
      return true
    }

    let isLoggedIn = false;
    if (store.getters['auth/loggedIn']) {
      isLoggedIn = true
    }

    if (await store.dispatch('auth/trySilentLogin')) {
      isLoggedIn = true
    }
    if (isLoggedIn) {
      if (requiresRole) {
        const roles = to.meta.roles || []

        if (!roles.some(value => store.getters['auth/user'].roles.split(',').includes(value))) {
          return {
            name: 'forbidden'
          }
        }
        return true;
      }
      else {
        return true;
      }
    }

    return {
      name: 'Login'
    }
  })

  app.config.globalProperties.$auth = instance
}

export default authHelper